requirejs.config({
	paths: {
		/** Local AMD */
		clipboard: `lib/clipboard.min`,
		jquery: `lib/jquery.min`,
		'jquery-mousewheel': `lib/jquery.mousewheel.min`,
		jstz: `lib/jstz.min`,
		livereload: `//localhost:35729/livereload`,
		lodash: `lib/lodash.min`,
		'libphonenumber-js': `lib/libphonenumber-js.min`,
		numeral: `lib/numeral.min`,
		nv: `lib/nv.d3.min`,
		papaparse: `lib/papaparse.min`,
		payform: `lib/payform.min`,
		q: `lib/q.min`,
		sortable: `lib/Sortable.min`,
		verge: `lib/verge`,

		/** Local Non-AMD, see shims below */
		d3: `lib/d3.min`,
		gator: `lib/gator.min`,
		Hammer: `lib/hammer.min`,
		'Hammer-time': `lib/hammer-time.min`,
		handlebars: `lib/handlebars.runtime.min`,
		// Use copied bundle from framework/js/lib (via grunt copy)
		libphonenumberjs: `lib/libphonenumber-min`,
		'mobile-detect': `lib/mobile-detect.min`,
		modernizr: `lib/modernizr-custom`,
		moment: `lib/moment.min`,
		moment_timezone: `lib/moment-timezone-with-data-1970-2030.min`,
		qrcode: `lib/qrcode.min`,
		tinymce: `lib/tinymce/tinymce.min`,

		/** External AMD */
		braintree: `//js.braintreegateway.com/js/braintree-2.32.1.min`,
		braintree_data: `//js.braintreegateway.com/v1/braintree-data`,
		seats_io: `https://cdn-na.seatsio.net/chart`,

		/** External Non-AMD, see shims below */
		facebook: `//connect.facebook.net/en_US/sdk`,
		localize: `https://global.localizecdn.com/localize`,
		markerclusterer: `lib/markerclusterer_compiled`,
		stripe: `//js.stripe.com/v3/?`, // avoid appending .js
		// Stripe Terminal SDK (global `StripeTerminal`)
		stripeTerminal: `https://js.stripe.com/terminal/v1/sdk`,
		stripeConnect: `https://connect-js.stripe.com/v1.0/connect`, // avoid appending .js
		youtube: `//www.youtube.com/iframe_api?`, // avoid appending .js
	},
	shim: {
		// Simple shims, import the global variable from window.___ into the namespace
		gator: { exports: `Gator` },
		Hammer: { exports: `Hammer` },
		jstz: { exports: `jstz` },
		localize: { exports: `Localize` },
		markerclusterer: { exports: `MarkerClusterer` },
		modernizr: { exports: `Modernizr` },
		moment_timezone: { deps: [`moment`] },
		nv: {
			deps: [`d3`],
			exports: `nv`,
		},
		// papaparse: {
		//     exports: 'Papa'
		// },
		qrcode: { exports: `QRCode` },
		stripe: { exports: `Stripe` },
		stripeTerminal: { exports: `StripeTerminal` },
		stripeConnect: { exports: `StripeConnect` },
		tinymce: { exports: `tinymce` },
	},
	config: {
		moment: {
			noGlobal: true,
		},
	},
	map: {
		// redirects to be used when dependencies are requested
		'*': {
			// global depencendency redirects, used for an extra layer of abstraction for prep
			d3: `d3-private`,
			Hammer: `Hammer-private`,
			jquery: `jquery-private`,
			lodash: `lodash-private`,
			StripeTerminal: `stripeTerminal`,
			// Redirect legacy ID to the new alias
			libphonenumber: `libphonenumberjs`,
			youtube: `youtube-private`,
			xregexp: `xregexp-private`,
		},
		// the private definitions define()'d in shared.js
		'd3-private': { d3: `d3` },
		'Hammer-private': { Hammer: `Hammer` },
		'jquery-private': { jquery: `jquery` },
		'jquery-mousewheel': { jquery: `jquery` },
		'lodash-private': { lodash: `lodash` },
		'xregexp-private': { xregexp: `xregexp` },
		'youtube-private': { youtube: `youtube` },
	},
});

//# sourceMappingURL=requirejs-config.js.map